import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Container,
  FormWrap,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
} from "./Styled";
import { signIn } from "../../axios/authServices";
import { useGlobalState } from "../../utils/stateContext";

const SignIn = () => {
  // sets the initial state of the form when the page is first loaded
  const initialFormState = {
    email: "",
    password: "",
  };

   // calls use state (which returns an array with 2 elements [first is list of the formState that is set above, and the 2nd is a function)
  const [formState, setFormState] = useState(initialFormState);

  // dispatch pass's the reducer action found in '../../utils/stateReducer.js
  const { dispatch } = useGlobalState();
  let history = useHistory();

  function handleChange(e) {
    setFormState({ // update whats currently in our form data state
      ...formState,
      [e.target.name]: e.target.value,
    });  // key/value pair: target name key for target value
  }

  function handleSubmit(e) {
    e.preventDefault();
    signIn(formState)
      .then(({ username, jwt }) => {
        sessionStorage.setItem("token", jwt); // assigns jwt generated by knock to 'token' 
        sessionStorage.setItem("user", username); // assigns the username to 'user'
        dispatch({ type: "setLoggedInUser", data: username }); // calls the Reducer action to "attach" the jwt to the loggedInUser for 24 hours
        dispatch({ type: "setToken", data: jwt });
        history.push("/portal"); //redirects back to the index page
      })
      .catch((err) => {
        setFormState(
          Object.assign({}, formState, { errorMessage: err.message }) // attach the jsx error below to the form if incorrect details are received.  Object.assign and formState keeps the correct fields populated
        );
      });
  }

  return (
    <>
      <Container>
        <FormWrap>
          <FormContent>
            <Form action="#">
              <FormH1>Employee Login:</FormH1>
              <FormLabel htmlFor="for">Email</FormLabel>
              <FormInput
                type="email"
                name="email"
                value={formState.username}
                initialValue=""
                onChange={handleChange}
              ></FormInput>
              <FormLabel htmlFor="for">Password:</FormLabel>
              <FormInput
                type="password"
                name="password"
                value={formState.password}
                initialValue=""
                onChange={handleChange}
              ></FormInput>
              {/* Display error message if error.message found in our formState */}
              {formState.errorMessage && (
                <p className="error" style={{ color: "white" }}>
                  {" "}
                  {"Oops! Please check your details and try again"}{" "}
                </p>
              )}
              <FormButton onClick={handleSubmit}>Log in</FormButton>
  
              <FormButton onClick={() => history.push(`/portal`)}>
                Back
              </FormButton>
            </Form>
          </FormContent>
        </FormWrap>
      </Container>
    </>
  );
};

export default SignIn;